import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Recurring from 'components/Shared/Icons/Recurring';
import { colors, fontSize } from 'styles/cp';

const ForcedAutopayDisplay = ({ autopayStartDate, localizedInterval }) => {
  const nextDate = autopayStartDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <Fragment>
      <div className="forced-autopay-display">
        <div className="autopay-description-row">
          <Recurring width={24} height={24} color={'#4C5558'} />
          <span className="autopay-description">
            <FormattedMessage
              id="FORCED_AUTOPAY_DESCRIPTION"
              defaultMessage="{interval} autopay will be turned on starting {nextDate}"
              values={{
                interval: localizedInterval,
                nextDate: nextDate,
              }}
            />
          </span>
        </div>
        <div className="autopay-cancel-info">
          <FormattedMessage
            id="FORCED_AUTOPAY_CANCEL_INFO"
            defaultMessage="Cancel autopay at any time."
          />
        </div>
      </div>
      <style jsx>{`
        .forced-autopay-display {
          padding-top: 8px;
        }

        .autopay-description-row {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          gap: 8px;
        }

        .autopay-description {
          font-size: ${fontSize.xs};
          color: ${colors.gray};
          line-height: 1.4;
          font-family: AvenirNextforINTUIT-Regular;
          margin: 0;
        }

        .autopay-cancel-info {
          font-size: ${fontSize.xs};
          color: ${colors.gray02};
          font-family: AvenirNextforINTUIT-Regular;
          line-height: 1.4;
          margin: 0;
          margin-left: 32px;
        }
      `}</style>
    </Fragment>
  );
};

export default ForcedAutopayDisplay;
